export const tableColumnNamesNominationAdministration = {
  'Nomination Id': 'nominationId',
  Candidate: 'candidate',
  Proposer: 'proposerName',
  'Sectional Committee': 'sectionalCommitteeId',
  'Election Type': 'electionTypeId',
  Round: 'roundYear',
  'Last Considered': 'lastConsidered',
  Status: 'nominationStatusType',
  nominationStatusTypeId: 'nominationStatusTypeId',
  Actions: 'actions',

  'Created at': 'createdAt',
  'Updated at': 'updatedAt',
  'Published at': 'publishedAt',
};
